import { ENewbuildingStatus, IFilters } from '../../types/filters';
import { TReduxActions } from '../../types/redux';
import { EFiltersActionTypes } from '../../actions';

export const defaultFiltersInitialState: IFilters = {
  developerId: 5747,
  newbuildingStatus: ENewbuildingStatus.All,
  regionId: 1,
  rooms: [],
  minPrice: null,
  maxPrice: null,
  minArea: null,
  maxArea: null,
};

export function filterReducer(state: IFilters = defaultFiltersInitialState, action: TReduxActions) {
  switch (action.type) {
    case EFiltersActionTypes.NewbuildingStatus:
      return { ...state, newbuildingStatus: action.payload };
    case EFiltersActionTypes.RegionChange:
      return { ...state, regionId: action.payload };
    case EFiltersActionTypes.RoomsChange:
      return { ...state, rooms: action.payload };
    case EFiltersActionTypes.MinPriceChange:
      return { ...state, minPrice: action.payload };
    case EFiltersActionTypes.MaxPriceChange:
      return { ...state, maxPrice: action.payload };
    case EFiltersActionTypes.MinAreaChange:
      return { ...state, minArea: action.payload };
    case EFiltersActionTypes.MaxAreaChange:
      return { ...state, maxArea: action.payload };

    default:
      return state;
  }
}
